import {Component, Input, OnInit} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-material-usage-campaign',
  templateUrl: './material-usage-campaign.component.html',
  styleUrls: ['./material-usage-campaign.component.scss']
})
export class MaterialUsageCampaignComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor() { }

  ngOnInit(): void {
  }

}
